import { useQuery } from "@tanstack/react-query";
import type { Brand } from "@contracts/api";
import { brandKeys, fetchBrands } from "./brands-api";

/** รายการแบรนด์ทั้งหมด — ใช้ทั้งหน้า My Job และ dropdown สลับแบรนด์ */
export function useBrands() {
  return useQuery({ queryKey: brandKeys.all, queryFn: fetchBrands });
}

/**
 * แบรนด์เดียวจากรายการเดิม (ไม่ยิงเพิ่ม)
 *
 * ระบุ id มาแล้วไม่เจอ = ไม่เจอจริง ๆ ห้ามถอยไปตัวแรกในรายการ — รายการนี้ถูก server
 * กรองตามสิทธิ์แล้ว การถอยไปตัวแรกทำให้คนที่เปิดแบรนด์ที่ไม่มีสิทธิ์ได้หน้าแบรนด์อื่น
 * มาแทนแบบเงียบ ๆ ทั้งที่ URL ยังเป็นอันเดิม
 */
export function useBrand(id: string | undefined) {
  const q = useBrands();
  const list: Brand[] = q.data ?? [];
  const brand = id ? (list.find((b) => b.id === id) ?? null) : (list[0] ?? null);
  return { ...q, brand, brands: list };
}
